document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".vw-premium-carousel").forEach(carousel => {

    const background =
      carousel.querySelector("#vwDynamicBackground");

    const row =
      carousel.querySelector(".vw-card-row");

    const cards =
      [...carousel.querySelectorAll(".vw-card")];

    if (!row || !cards.length) return;


    /* ================================
       PRELOAD BACKGROUNDS
       ================================ */

    cards.forEach(card => {

      const desktopBg = card.dataset.bg;
      const mobileBg = card.dataset.mobileBg;

      if (desktopBg) {
        const img = new Image();
        img.src = desktopBg;
      }

      if (mobileBg) {
        const img = new Image();
        img.src = mobileBg;
      }

    });


    /* ================================
       CHANGE BACKGROUND
       DESKTOP ONLY
       ================================ */

    function changeBackground(url) {

      if (!background || !url) return;

      background.removeAttribute("srcset");
      background.src = url;

    }


    /* ================================
       DESKTOP HOVER
       ================================ */

    cards.forEach(card => {

      card.addEventListener("mouseenter", () => {

        if (window.innerWidth <= 749) return;

        cards.forEach(c => {
          c.classList.remove("is-active");
        });

        card.classList.add("is-active");

        changeBackground(card.dataset.bg);

      });

    });


    /* ================================
       MOBILE
       ================================ */

    /*
      Mobile carousel/swipe is intentionally
      disabled.

      CSS handles the mobile layout as:

      2 columns × multiple rows

      All cards remain visible at once.
    */

    function resetMobileState() {

      if (window.innerWidth > 749) return;

      cards.forEach(card => {
        card.classList.remove("is-active");
      });

      /*
        Do not apply any transform from JS.
        The CSS grid controls the position.
      */

      row.style.transform = "none";

    }


    /* ================================
       INITIAL STATE
       ================================ */

    if (window.innerWidth <= 749) {

      resetMobileState();

    } else {

      cards[0].classList.add("is-active");

      changeBackground(cards[0].dataset.bg);

    }


    /* ================================
       RESIZE
       ================================ */

    window.addEventListener("resize", () => {

      if (window.innerWidth <= 749) {

        resetMobileState();

      } else {

        row.style.transform =
          "translateY(25px)";

        cards.forEach((card, index) => {

          card.classList.toggle(
            "is-active",
            index === 0
          );

        });

        changeBackground(
          cards[0].dataset.bg
        );

      }

    });

  });

});